import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";
import { CardWrapType1, Column, CardImage } from "styles/MainCards.styled";

export const EmptyProducts = styled.div`
  font-size: 24px;
  font-family: ${fonts.abhayaRegular};
  color: ${colors.GREY};
  background: linear-gradient(180deg, rgba(242, 243, 245, 0.5) 0%, rgba(242, 243, 245, 0) 100%);
  border-radius: 20px;
  height: 300px;
  text-align: center;
  padding-top: 50px;
`;

export const Title = styled.div`
  font-family: ${fonts.abhayaRegular};
  color: ${colors.GREY_DARK};
  font-size: 30px;
`;

export const ShowMore = styled.div`
  text-align: center;
  cursor: pointer;
  color: ${colors.RED};
`;

export const CollectionsCardsWrap = styled(CardWrapType1)`
  padding-bottom: 50px;
  ${Column}:not(.add-collection-button) {
    padding-right: 24px;
    padding-top: 16px;
    @media (min-width: 1024px) {
      padding-left: 15px;
      padding-right: 31px;
      padding-top: 16px;
      flex: 0 0 20%;
      max-width: 20%;
      margin-top: 30px;
    }
  }
  ${Column}.add-collection-button {
    @media (min-width: 1024px) {
      flex: 0 0 20%;
      max-width: 20%;
    }
  }
  ${CardImage} {
    padding-top: 100%;
    box-shadow: 8px -8px ${colors.GREY_SEMILIGHT}, 16px -16px ${colors.GREY_LIGHT};
  }
`;

export const CollectionsListWrapper = styled.div`
  margin-top: 40px;
  color: ${colors.GREY_DARK};
`;

export const RecipesCardsWrap = styled(CardWrapType1)`
  ${Column} {
    @media (min-width: 1024px) {
      flex: 0 0 20%;
      max-width: 20%;
    }
  }
  ${CardImage} {
    padding-top: 100%;
  }
`;

export const RecipesListWrapper = styled.div`
  color: ${colors.GREY_DARK};
`;

export const CreatorProductsWrapper = styled.div``;
